import { useQuery } from '@tanstack/react-query';

import useQreId from '../../../hooks/useQreId';
import { getSampleRowsByQreIdSurveyDataOptions } from '../../generated-evs/@tanstack/react-query.gen';

const useProjectSurveyQuery = () => {
  const { qreId } = useQreId();

  return useQuery(getSampleRowsByQreIdSurveyDataOptions({ path: { qreId } }));
};

export default useProjectSurveyQuery;
